import type { SizeType } from "@jobteaser/spark/components/Avatar/Avatar"
import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import Image from "next/image"

import { Avatar } from "@jobteaser/spark/components/Avatar"
import { User } from "@jobteaser/spark/components/Icons/User"

import styles from "./UserAvatar.module.css"

type UserAvatarProps = {
  alt?: string
  className?: string
  size?: Extract<SizeType, 24 | 32 | 64>
  src?: string
}

export const UserAvatar: FunctionComponent<UserAvatarProps> = ({ alt = "", className, size = 24, src = "" }) => {
  if (!src) {
    return (
      <Avatar
        className={clsx(styles["userAvatar--default"], className)}
        data-testid="user-avatar-default"
        fallbackIcon={User}
        shape="rounded"
        size={size}
      />
    )
  }

  return (
    <Avatar shape="rounded" size={size}>
      <Image
        alt={alt}
        className={clsx(styles["userAvatar--default"], className)}
        data-testid="user-avatar-image"
        fill
        src={src}
      />
    </Avatar>
  )
}
